// TODO:
// improve this factory to handle all requests inside components

import axios from 'axios';
import { isPresent, toLowerCamelCase, toSnakeCase, deepTransformObjectKeys } from '@fretadao/f-js-utils';

const apiSnakeCaseWords = ['_destroy'];
const fromRubyAPIFormat = (response) => deepTransformObjectKeys(response.data, toLowerCamelCase);
const toAPISnakeCase = (attribute) => apiSnakeCaseWords.includes(attribute) ? attribute : toSnakeCase(attribute);
const toRubyAPIFormat = (body) => deepTransformObjectKeys(body, toAPISnakeCase);

const boardingAuthorization = {
  create: params => axios.post('/boarding_authorizations', params),
};

const waypoint = {
  staticImage: (waypointId, imageKind) => axios.get(`/waypoint/${waypointId}/static_image/${imageKind}`),
};

const busOperatorLineTransfer = {
  getTable: (slug, lineId, query) => axios.get(`/transportadores/${slug}/linhas/${lineId}/repasses/table?${query}`)
};

const api = {
  fetchGarages: (lineId) => axios.get(Routes.api_line_garages_path(lineId))
}

const maps = {
  createRouting: (csrfToken, { coordinates, engine, vehicleCharacteristics }) => {
    const body = { coordinates: coordinates, engine: engine, vehicleCharacteristics: vehicleCharacteristics };
    const headers = { 'X-CSRF-Token': csrfToken, 'Content-Type': 'application/json' };

    return axios
      .post(Routes.api_maps_routings_path(), toRubyAPIFormat(body), { headers: headers })
      .then(fromRubyAPIFormat);
  }
};

const distanceBetweenOriginAndDestination = {
  getDistance: (origin, destination, provider, csrfToken) => {
    return axios.get(
      '/api/maps/distances',
      {
        params: { origin: origin, destination: destination, provider: provider },
        headers: { 'X-CSRF-Token': csrfToken }
      },
    )
  }
};

const admin = {
  fetchSubscriptions: (lineId) => axios.get(Routes.admin_line_subscriptions_path(lineId, { format: 'json' })),
  travelPlan: {
    fetch: (lineId, id) => {
      return axios
        .get(Routes.admin_line_line_travel_plan_path(lineId, id, { format: 'json' }))
        .then(fromRubyAPIFormat);
    },
    update: (lineId, id, content, csrfToken) => {
      const headers = { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken };
      const body = toRubyAPIFormat(content);
      return axios
        .patch(Routes.admin_line_line_travel_plan_path(lineId, id, { format: 'json' }), body, { headers: headers })
        .then(fromRubyAPIFormat);
    }
  }
}

const b2bAdmin = {
  arrivalsAndDepartures: (agreement, csrfToken) => {
    return axios.get(
      `/b2b/${agreement}/chegadas_e_saidas.js`,
      {
        headers: {
          'X-CSRF-Token': csrfToken,
          'X-Requested-With': 'XMLHttpRequest'
        },
      }
    );
  },

  calculateNewDestinationTimes: (agreementSlug, destinationId, lineIds, csrfToken) => {
    return axios.get(`/b2b/api/routing/calculate-destination`, {
      headers: {
        'X-CSRF-Token': csrfToken,
      },
      params: {
        slug: agreementSlug,
        destination_id: destinationId,
        line_ids: lineIds
      }
    });
  },

  tripDetailCheckIns: (agreementSlug, tripDetailId) => {
    return axios.get(
      `/b2b/api/${agreementSlug}/trip_details/${tripDetailId}/check_ins`
    );
  },

  customRouting: (csrfToken, agreementSlug, waypoints) => {
    return axios.get(`/b2b/api/routing/custom-routing`, {
      headers: {
        'X-CSRF-Token': csrfToken,
      },
      params: {
        slug: agreementSlug,
        waypoints: waypoints
      }
    });
  },

  routingLocate: (csrfToken, agreementSlug, coords) => {
    const headers = { 'X-CSRF-Token': csrfToken };
    const params = {
      slug: agreementSlug,
      latitude: coords[0],
      longitude: coords[1]
    };

    return axios.get(`/b2b/api/routing/locate`, { headers: headers, params: params }).then(fromRubyAPIFormat);
  }
};

const rideRequest = {
  api: {
    reverseGeocode: async (latitude, longitude) => {
      return axios.get(`/transporte-individual/api/reverse_geocode?latitude=${latitude}&longitude=${longitude}`).then(fromRubyAPIFormat)
    },
    locations: (query) => axios.get(`/transporte-individual/api/locations?query=${query}`),
    voucherTripStatus: async (voucherCode) => {
      return axios.get(`/transporte-individual/api/voucher_trip_status/${voucherCode}`).then(fromRubyAPIFormat)
    },
  }
}

const superset = {
  fetchGuestToken: (csrfToken, path, body) => {
    const headers = {
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/json",
    }

    return axios.post(path, body, { headers: headers }).then(response => response.data.token)
  }
}

export const API = {
  api,
  maps,
  distanceBetweenOriginAndDestination,
  busOperatorLineTransfer,
  boardingAuthorization,
  waypoint,
  admin,
  b2bAdmin,
  rideRequest,
  superset
};
